import { state as init } from "../../GlobalState";
import * as actions from "./actions";

const reducer = (state = init, action) => {
  switch (action.type) {
    case actions.GET_BANNERS: {
      return { ...state, loading: true, error: "" };
    }
    case actions.CREATE_BANNERS: {
      return { ...state, loading: true, error: "" };
    }
    case actions.BANNERS_FAILURE: {
      console.log(action.payload.error, "error");
      return { ...state, loading: false, error: action.payload.error };
    }
    case actions.BANNERS_SUCCESS: {
      const payload = action.payload;
      return {
        ...state,
        ...payload,
      };
    }

    default:
      return state;
  }
};

export default reducer;
